import SkillsExperiments from 'bundles/epic/clients/Skills';

const isSkillTrackingExperimentEnabled = (orgSlug: string) => {
  if (!orgSlug) return false;
  const enabledOrgs: string[] = SkillsExperiments.get('enableAdminFavSkills') || [];
  return enabledOrgs.includes(orgSlug);
};

export { isSkillTrackingExperimentEnabled };
